import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from '../../config';
import { DostavnicaHladService } from './dostavnica-hlad.service';

@Component({
  selector: 'app-dostavnica-hlad',
  templateUrl: './dostavnica-hlad.component.html',
  styleUrls: ['./dostavnica-hlad.component.scss'],
  providers: [DostavnicaHladService],
})
export class DostavnicaHladComponent implements OnInit {
  tablica: any;
  poruka: string;
  datumOd = moment();
  datumDo = moment();
  o = moment().format('YYYY-MM-DD');
  d = moment().format('YYYY-MM-DD');
  strane: any;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: DostavnicaHladService) {
    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().dostavnicaHlad;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.prometRobe(this.o, this.d);
    this.strane = [{ naziv: 'L' }, { naziv: 'D' }];
  }

  prometRobe(o, d) {
    let object = {
      datumod: o,
      datumdo: d,
    };
    console.log(object);
    this.tablica = [];
    this.service.prometHlad(object).subscribe((res) => {
      console.log(res);
      if (res.success == true) {
        if (res.data.length == 0) {
          this.poruka = 'Nema podataka!';
        } else {
          this.poruka = 'Učitavanje...';
        }
        for (let data of res.data) {
          this.tablica.push({
            sifra: data.ar_sifra,
            lot: data.ar_lot,
            idlot: data.idlotpromet,
            naziv: data.ar_naziv,
            datum: moment(data.do_datum).format('DD.MM.YYYY.'),
            kolicina: data.pr_ulaz,
            kutija: data.br_kutija,
            komora: data.komora_idkomora,
            redak: data.red_idred,
            strana: data.strana,
            dokumentBroj: data.do_broj,
            vrstaDokumenta: data.dv_sifra,
            regOznaka: data.reg_oznaka,
            rbKamiona: data.rb_kamiona,
          });
        }
      } else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
  }

  urediPoziciju(data) {
    // console.log(data);
    let object = {
      idstrana: data.data.strana,
      idred: data.data.redak,
      idkomora: data.data.komora,
      idlotpromet: data.data.idlot,
    };
    console.log(object);
    if (object.idstrana === 'L' || object.idstrana === 'D') {
      this.service.urediPoziciju(object).subscribe((res) => {
        console.log(res);
        if (res.success == true) {
          this.prometRobe(this.o, this.d);
          notify('Uspješna promjena!', 'success', 3000);
        }
      });
    } else {
      this.prometRobe(this.o, this.d);
      notify('Strana mora biti L ili D.', 'warning', 3000);
    }
  }

  // Promjena datuma
  onValueChangedDatumOd(e) {
    // console.log(e);
    this.datumOd = e.value;
    this.o = moment(e.value).format('YYYY-MM-DD');
    this.prometRobe(this.o, this.d);
  }
  onValueChangedDatumDo(e) {
    // console.log(e);
    this.datumDo = e.value;
    this.d = moment(e.value).format('YYYY-MM-DD');
    this.prometRobe(this.o, this.d);
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }
}
